export enum TollFreeHeaders {
  TollFreeNumber = 1,
  Reserve = 2,
  Inquire = 3,
  BulkUpload = 4
}
